import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReportStatus } from '../../types';
import './StatusBadge.css';

interface StatusBadgeProps {
  status: ReportStatus;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const { t } = useTranslation();

  const getStatusClass = (status: ReportStatus): string => {
    switch (status) {
      case ReportStatus.NEW:
        return 'status-badge-new';
      case ReportStatus.READY:
        return 'status-badge-ready';
      case ReportStatus.IN_PROGRESS:
        return 'status-badge-in-progress';
      case ReportStatus.SIGNED:
        return 'status-badge-signed';
      case ReportStatus.CLOSED:
        return 'status-badge-closed';
      case ReportStatus.CANCELED:
        return 'status-badge-canceled';
      default:
        return '';
    }
  };

  return (
    <span className={`status-badge ${getStatusClass(status)}`}>
      {t(`status.${status}`)}
    </span>
  );
};

export default StatusBadge;
